import { Tooltip } from 'bootstrap'
import enterView from 'enter-view'
import { CountUp } from 'countup.js'
const { body, documentElement } = document

export default {
	init() {
		window.addEventListener('scroll', () => {
			if (body.getBoundingClientRect().top < 0) {
				body.classList.add('header-hide')
			} else {
				body.classList.remove('header-hide')
			}

			// if (body.getBoundingClientRect().top > scrollPos) {
			// 	body.classList.add('scrollup')
			// } else if (body.getBoundingClientRect().top < scrollPos) {
			// 	body.classList.remove('scrollup')
			// }

			// clearTimeout(timeout)

			// timeout = setTimeout(function () {
			// 	scrollPos = body.getBoundingClientRect().top
			// }, 100)
		})

		enterView({
			offset: 1,
			selector: '.main-content',
			enter: (el) => {
				body.classList.add('menu-sticky')
			},
			exit: (el) => {
				body.classList.remove('menu-sticky')
			},
		})

		if (document.querySelector('.home-stats')) {
			enterView({
				selector: '.home-stats',
				enter: (el) => {
					for (const item of document.querySelectorAll('.stat-count')) {
						const countUp = new CountUp(item, item.dataset.number)
						if (!countUp.error) {
							countUp.start()
						} else {
							console.error(countUp.error)
						}
					}
				},
				offset: 0.5,
				once: true,
			})
		}
	},

	finalize() {
		setTimeout(() => {
			const tooltipTriggerList = [].slice.call(
				document.querySelectorAll('[data-bs-toggle="tooltip"]')
			)

			tooltipTriggerList.map((tooltipTriggerEl) => {
				return new Tooltip(tooltipTriggerEl)
			})
		}, 400)
	},
}
